<template>
    <div
        :class="[
            'z-contact-person',
            `z-contact-person--image-${imagePosition}`,
            `z-contact-person--size-${size}`
        ]">
        <div
            v-if="!hideImage"
            class="z-contact-person__image"
            :style="`background-image: url(${image ? image : '/images/male.jpg'});`"
        ></div>
        <div class="z-contact-person__container">
            <p
                class="z-contact-person__name"
                v-if="name"
                v-html="name"></p>
            <div class="z-contact-person__description">
                <div
                    v-if="description"
                    v-html="description"></div>
                <slot name="detail" />
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    image: {
        type: String,
        default: ''
    },
    imagePosition: {
        type: String,
        default: 'left',
        validator: (prop) => ['left', 'top'].includes(prop)
    },
    size: {
        type: String,
        default: 'm',
        validator: (prop) => ['l', 'm', 's'].includes(prop)
    },
    name: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    hideImage: {
        type: Boolean,
        default: false
    }
})
</script>

<style lang="scss" src="./index.scss"></style>
